import React from 'react'
import { AppContainer } from '@brainstud/react-tbl/themes/pgw/v1/components/layout'
import { PageContent, Animation } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './ModalPage.css'

const ModalPage = props => (
  <div className={`Modal Modal-page Modal-${props.name}`}>
    <div className="Modal-content">
      <Animation>
        <AppContainer>
          <PageContent>
            {props.children}
          </PageContent>
        </AppContainer>
      </Animation>
    </div>
    <div className="Modal-underlay" />
    <div className="Modal-overlay">
    {!props.noclose &&
      <Animation name="slideInDown">
        <div className="Modal-svg">
          <svg viewBox="0 0 300 200" preserveAspectRatio="xMinYMin slice">
            <g>
              <polygon points="0 0 300 86 300 200 0 114 0 0" />
            </g>
          </svg>
        </div>
        <a className="Modal-close" onClick={props.app.toggleModal}>&times;</a>
      </Animation>
    }
    </div>
  </div>
)

export default ModalPage
